var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.91891 0.0919174C8.91891 0.0919174 14.1379 -0.142872 16.9038 5.10211H8.47533C8.47533 5.10211 6.8834 5.0497 5.52666 6.98123C5.13548 7.7904 4.7179 8.62516 5.18747 10.2691C4.5091 9.12114 1.58643 4.03256 1.58643 4.03256C1.58602 4.03215 3.64794 0.300709 8.91891 0.0919174Z",
    fill: "#E6322A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.632 13.4087C16.632 13.4087 14.2252 18.0452 8.2998 17.8173C9.03098 16.552 12.515 10.5186 12.515 10.5186C12.515 10.5186 13.3563 9.16629 12.3631 7.02557C11.8582 6.2822 11.3439 5.50269 9.68539 5.08754C11.0194 5.07414 16.8871 5.08835 16.8871 5.08835C16.8871 5.08835 19.0875 8.73977 16.632 13.4087Z",
    fill: "#FEDA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.24281 13.4441C1.24281 13.4441 -1.56897 9.04118 1.59134 4.02368C2.3217 5.28943 5.80414 11.3241 5.80414 11.3241C5.80414 11.3241 6.55441 12.7288 8.90514 12.9392C9.80124 12.8738 10.7335 12.8181 11.9225 11.5897C11.2668 12.7511 8.3206 17.8259 8.3206 17.8259C8.3206 17.8259 4.05825 17.9055 1.24281 13.4441Z",
    fill: "#65B54C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30029 17.8602L9.48602 12.913C9.48602 12.913 10.7895 12.8114 11.8818 11.6123C11.2039 12.8049 8.30029 17.8602 8.30029 17.8602Z",
    fill: "#60AC48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94836 9.03055C4.94836 6.84961 6.71619 5.08179 8.89713 5.08179C11.0781 5.08179 12.8459 6.84961 12.8459 9.03055C12.8459 11.2115 11.0781 12.9797 8.89713 12.9797C6.71619 12.9797 4.94836 11.2119 4.94836 9.03055Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60925 9.03054C5.60925 7.21478 7.08136 5.74268 8.89752 5.74268C10.7137 5.74268 12.1854 7.21478 12.1854 9.03054C12.1854 10.8463 10.7133 12.3184 8.89752 12.3184C7.08176 12.3184 5.60925 10.8463 5.60925 9.03054Z",
    fill: "url(#paint0_linear_13_271)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8872 5.08824L12.0054 6.51972C12.0054 6.51972 11.2693 5.4392 9.68591 5.08742C11.0577 5.08255 16.8876 5.08824 16.8876 5.08824H16.8872Z",
    fill: "#F1CF00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09242 10.0912C4.40633 8.90309 1.58643 4.03223 1.58643 4.03223L5.20291 7.60971C5.20291 7.60971 4.83123 8.3742 4.97218 9.46609L5.09242 10.0912Z",
    fill: "#DA3027"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13_271",
    x1: 8.89711,
    y1: 5.78939,
    x2: 8.89711,
    y2: 12.1218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96C1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#146CB5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChrome);
export default __webpack_public_path__ + "static/media/icon_chrome.3058bc8298b090b29aed2cc2ba604fa4.svg";
export { ForwardRef as ReactComponent };